// Mutation_Types
export const SET_FIRST_PROC = 'SET_FIRST_PROC'
export const SET_QUESTION_INDEX = 'SET_QUESTION_INDEX'
export const SET_CURRENT_GAME = 'SET_CURRENT_GAME'
export const SET_SOUNTDS_MUTE = 'SET_SOUNTDS_MUTE'
export const SET_BGM_MUTE = 'SET_BGM_MUTE'
export const SET_CURRENT_SCREEN_SIZE = 'SET_CURRENT_SCREEN_SIZE'

